<input (change)="onFileChange($event)"
       [attr.data-cy]="inputDataCy"
       [attr.disabled]="disabled ? 'disabled' : null"
       accept=".json"
       id="file"
       type="file"/>

<label [attr.data-cy]="labelDataCy"
       [attr.disabled]="disabled ? 'disabled' : null"
       class="button btn-text-link"
       for="file"><span class="iwp-icon-gen_upload"></span><span>{{buttonText}}</span>
</label>
